'use client';

import { Button } from '@/components/ui/button';
import { requestCookieSettings } from '@/lib/cookie-settings';

export function CookieSettingsButton() {
  return (
    <Button type="button" variant="secondary" onClick={requestCookieSettings}>
      Cookie settings
    </Button>
  );
}
